import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;

  .authorization-title {
    text-align: left;
    margin: 16px 0; 
  }

  .drivers {
    max-width: 1000px;
    max-height: 200px;
    overflow-y: auto;

    .no-drivers {
      font-family: ManropeLight, sans-serif;
      font-size: 13px;
      margin: 5px 0;
      font-style: italic;
      color: ${(props) => props.theme.colors.orange}
    }

    &::-webkit-scrollbar {
      width: 12px;
    }
  
    &::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.widget_background};
    }
  
    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.colors.inactive};
      border-radius: 20px;
      border: 3px solid ${(props) => props.theme.colors.inactive};
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    button {
      margin: 0 auto;
    }
    
  }
`;

const ErrorMessage = styled.p`
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  text-align: center;
  margin: 5px 0;
  color: ${(props) => props.theme.colors.red}
`;

export default { Wrapper, ErrorMessage };
